/// <amd-module name="SuiteCommerce.StockNotifications.Shopping"/>
define("SuiteCommerce.StockNotifications.Shopping", ["require", "exports", "SuiteCommerce.StockNotifications.Header", "SuiteCommerce.StockNotifications.PDP", "SuiteCommerce.StockNotifications.Component", "SuiteCommerce.StockNotifications.Common.InstrumentationHelper", "SuiteCommerce.StockNotifications.Configuration"], function (require, exports, Header, PDP, Component, InstrumentationHelper_1, Configuration_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            InstrumentationHelper_1.InstrumentationHelper.initializeInstrumentation(container.getComponent('Environment'));
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            Header.mountToApp(container);
            PDP.mountToApp(container);
            Component.register(container);
        }
    };
});
